export default "__VITE_ASSET__B2J$6SpQ__"